import { ClassName } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import Typography from 'components/foundation/text/Typography/Typography';

export interface IDashboardCardTextButtonProps {
  children: string;
  onClick?: (event: React.MouseEvent) => void;
  className?: ClassName;
}

export default function DashboardCardTextButton({ children, onClick, className }: IDashboardCardTextButtonProps) {
  const classes = classNames('dashboard-card-text-button', className);

  return (
    <Typography className={classes} tag="span" onClick={onClick} fontSize="0.9em">
      {children}
    </Typography>
  );
}
